import { GuestOfHonor } from './guestOfHonor';

export interface WaiverBooking {
  id?: number;
  accountId?: number;
  guestsOfHonor?: GuestOfHonor[];
  parkId?: string;
}
